import { type Meta } from '../types/docs';

const META: Meta = {
  description:
    'Agent run settled (its HTTP stream cleanly ends); used to detect hangs where the result arrives but the stream never closes',
  name: 'agent_chat_run_settled',
  params: [
    {
      description: 'The ID of the canvas',
      name: 'canvas_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The ID of the chat thread',
      name: 'thread_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The ID of the agent run',
      name: 'run_id',
      required: false,
      type: 'string',
    },
    {
      description:
        'The programmatic transform action name (e.g. removeBackground, editTextOcr); absent for plain chat prompts',
      name: 'action',
      required: false,
      type: 'string',
    },
    {
      description: 'Milliseconds from run start (RUN_STARTED) to settle (stream EOF)',
      name: 'duration_ms',
      required: true,
      type: 'number',
    },
    {
      description: "Whether the server's RUN_FINISHED event was received before settle",
      name: 'run_finished_received',
      required: true,
      type: 'boolean',
    },
    {
      description:
        'Whether a node-materializing result (a completed edit or generated text) arrived during the run; intermediate probes like detect_text do not count',
      name: 'result_arrived',
      required: true,
      type: 'boolean',
    },
    {
      description:
        "How the run ended: 'finished' = RUN_FINISHED received; 'errored' = run error; 'aborted' = stopped by the user; 'abandoned' = stream died without a terminal event",
      name: 'outcome',
      required: true,
      type: 'enum',
      values: ['finished', 'errored', 'aborted', 'abandoned'],
    },
    {
      description:
        'Whether the browser tab was hidden at settle time (in the background, minimized, or the machine asleep)',
      name: 'tab_hidden',
      required: true,
      type: 'boolean',
    },
    {
      description: 'Canvas Animate variant count requested for this run (1-4), when it carried one',
      name: 'variant_count_requested',
      required: false,
      type: 'number',
    },
    {
      description: 'Variants delivered via file_edit_complete; 0 when none landed',
      name: 'variant_count_delivered',
      required: false,
      type: 'number',
    },
    {
      description: 'Which surface wrote the requested variant count',
      name: 'variant_count_source',
      required: false,
      type: 'enum',
      values: ['toolbar_pill', 'composer_pill'],
    },
  ],
};

export default META;
